import React, {useEffect} from "react";
import styled from "styled-components";
import {ModalBody} from "./Modal";
import IcClose from "../icons/IcClose";

const FitGuidePreviewModal = ({content, handleCloseModal, modalDepth}) => {
    useEffect(() => {
        const messageHandler = function (e) {
            const messageData = e.data;
            if (messageData.id === "andar-detail-page") {
                const iframe = document.getElementById(messageData.id);
                iframe.style.height = messageData.height + 'px';
            }
        };
        window.addEventListener('message', messageHandler)
        return () => {
            window.removeEventListener('message', messageHandler);
        }
    }, []);
    const resizeIframe = (iframe) => {
        iframe.style.width = "100%";
        const iframeDocument = iframe.contentDocument;
        if (!iframeDocument) return;
        const contentHeight = iframeDocument.documentElement.getBoundingClientRect().height;
        if (iframe) {
            iframe.style.height = `${contentHeight}px`;
        }
    };

    if (content.length === 0) {
        return;
    }
    return (
        <ModalBody id={"fitGuidePreview"}>
            <EditPreviewWarp className={"fit-guide-preview-modal"}>

                <div className="fit-guide-content-container">
                    <div className="title">
                        기장 가이드 보기
                        <button className={"modal-close"} onClick={() => {
                            handleCloseModal(modalDepth)
                        }}>
                            <IcClose color={"#7B848D"} size={24}/>
                        </button>
                    </div>
                    <div className="fit-guide-content-wrapper">
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe className={"fit-guide-modal-inner-iframe"}
                                id={"andar-detail-page"}
                                srcDoc={content}
                                onLoad={(e) => {
                                    resizeIframe(e.target)
                                }}
                        >
                        </iframe>
                    </div>
                </div>
            </EditPreviewWarp>
        </ModalBody>
    );
};


const EditPreviewWarp = styled.article`

    margin: 0 auto;
    //overflow: hidden;
    //background-color: #f5f5f5;
    //padding: 32px;

    background-color: rgb(241, 243, 245);
    overflow: hidden;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;


    .title {
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 16px;
        position: relative;
        border-bottom: 1px solid #dfe4ea;
        color: #353535;

        .modal-close {
            position: absolute;
            top: 50%;
            right: 20px;
            transform: translateY(-50%);
        }
    }


    .fit-guide-content-container {
        background: #fff;
        border: 1px solid #dfe4ea;
        position: relative;
        overflow: auto;
        height: 100%;
    }


    div.code-copy-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        //.spec-view {
        //    display: none;
        //}
    }

    div.preview-content-container {
        margin-top: 16px;

        div.preview-content-wrapper {
            height: 600px;
            background-color: #fff;
            padding: 0 28px;
            overflow: auto;
            position: relative;
            display: flex;

            img {
                max-width: 100%;
            }

            .preview-modal-inner-iframe {
                margin: 0 auto;
                width: 775px; // pc 기준으로 잡음
            }
        }

        div.nav-tab-wrap {
            display: flex;
            align-items: center;
            border: 1px solid var(--line-table-section-line, #eee);

            div.nav {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 44px;
                width: 50%;
                background-color: var(--disabled-bg-colored, #f5f5f5);

                span {
                    color: var(--enabled-lgt, #b0b0b0);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 20px;
                    letter-spacing: -0.28px;
                }

                &.active {
                    background-color: var(--txt-table-label, #555);

                    span {
                        color: var(--White_-FFFFFF, #fff);
                    }
                }
            }
        }
    }
`;


export default FitGuidePreviewModal;
